import React from "react";
import { Link } from "react-router-dom";
import { Heart, X } from "lucide-react";
import { useShop } from "@/context/ShopContext";
import { formatINR, optImg } from "@/lib/api";
import { PaisleyDivider, Lotus } from "@/lib/motifs";

const Wishlist = () => {
    const { wishlist, toggleWishlist } = useShop();

    return (
        <div className="container-x py-16" data-testid="wishlist-page">
            <div className="text-center mb-12">
                <Lotus className="mx-auto mb-3" />
                <p className="font-devanagari text-[color:var(--gold)] text-sm">प्रिय पसंद</p>
                <h1 className="font-heading text-5xl text-[color:var(--maroon)] mt-1">Your Wishlist</h1>
                <PaisleyDivider className="mt-4" />
            </div>

            {wishlist.length === 0 ? (
                <div className="text-center py-20 border border-[color:var(--border-gold)] max-w-xl mx-auto">
                    <Heart size={40} className="mx-auto text-[color:var(--maroon)]" strokeWidth={1.2} />
                    <p className="font-heading text-2xl text-[color:var(--maroon)] mt-4">No treasures saved yet</p>
                    <p className="font-body text-[color:var(--ink-muted)] mt-2 max-w-sm mx-auto">Tap the heart on any piece you love to keep it close.</p>
                    <Link to="/shop" className="btn-primary mt-6 inline-flex" data-testid="wishlist-empty-shop">Explore Collection</Link>
                </div>
            ) : (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" data-testid="wishlist-grid">
                    {wishlist.map((p, i) => (
                        <div key={p.id} className="group rise-in" style={{ animationDelay: `${i * 60}ms` }} data-testid={`wishlist-item-${p.id}`}>
                            <div className="relative border border-[color:var(--border-gold)] bg-white overflow-hidden" style={{ borderTopLeftRadius: '999px', borderTopRightRadius: '999px' }}>
                                <Link to={`/product/${p.id}`}>
                                    <img src={p.image} alt={p.name} className="w-full aspect-[3/4] object-cover transition-transform duration-700 group-hover:scale-105" />
                                </Link>
                                <button
                                    onClick={() => toggleWishlist(p)}
                                    className="absolute top-3 right-3 w-8 h-8 rounded-full bg-[color:var(--ivory)]/95 border border-[color:var(--border-gold)] flex items-center justify-center hover:bg-[color:var(--maroon)] hover:text-[color:var(--ivory)] text-[color:var(--maroon)] transition-colors duration-300"
                                    aria-label="Remove"
                                    data-testid={`remove-wishlist-${p.id}`}
                                >
                                    <X size={14} />
                                </button>
                            </div>
                            <div className="pt-4 text-center">
                                <p className="font-ui text-[10px] tracking-widest-x uppercase text-[color:var(--copper)]">{p.material}</p>
                                <Link to={`/product/${p.id}`} className="font-heading text-lg text-[color:var(--maroon)] block hover:text-[color:var(--copper)] transition-colors duration-300 mt-1">{p.name}</Link>
                                <p className="font-body text-[color:var(--gold)] font-semibold mt-1">{formatINR(p.price)}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Wishlist;
